import { Serializable } from '../../../core/models/serializable';
import { PostingChannel } from './posting-channel.enum';
import { ThreadModel } from './thread-model';
import { UserModel } from '@admin/core/user-model.model';

export class ThreadPostModel implements Serializable<ThreadPostModel> {
  fromObject(object: any): ThreadPostModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public threadPostId: number;
  public thread: ThreadModel;
  public text: string;
  public postingChannelId: PostingChannel;
  public replyToPostId: number;
  public createDate: Date;
  public createUser: UserModel;
  public isLocked: boolean;
  public isDeleted: boolean;
  public deleteDate: Date;
  public deleteUserId: number;

  public get threadId(): number {
    return this.thread.threadId;
  }
}
